import { BREAKPOINTS } from "../../config/breakpoints";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import InputBox from "../../Generic/InputBox";
import { get, getApi, post } from "../../config/api";
import { zIndex } from "../../config/zIndex";

const Div = styled.div`
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	position: ${(props) => props.position};
	width: ${(props) => props.width};
	display: ${(props) => props.display};
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	transition: 0.1s background ease-in-out;
	border-radius: ${(props) => props.borderRadius};
	top: ${(props) => props.top};
	bottom: ${(props) => props.bottom};
	left: ${(props) => props.left};
	right: ${(props) => props.right};
	transition: 0.6s background ease-in-out;
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		justify-content: ${(props) => props.jContentBefore1000};
	}
`;

Div.defaultProps = {
	display: "flex",
};

const Dropdown = styled.div`
	width: 100%;
	position: absolute;
	height: max-content;
	max-height: 12rem;
	overflow-x: hidden;
	overflow-y: scroll;
	border: 1px solid #b3b3b3;
	background-color: #fff;
	z-index: ${zIndex.dropdown};
`;

const Item = styled.li`
	width: 100%;
	padding: 0.8rem 0.5rem;
	cursor: pointer;
	&:hover {
		background-color: #f1f1f1d7;
	}
	border-bottom: 1px solid #b3b3b36b;
	visibility: visible;
	list-style-type: none;
	background-color: #fff;
`;

const Text = styled.div`
	color: #090a3c;
	margin-bottom: 5px;
`;

export const SearchBarWithResults = (props) => {
	const { onChange, colToStore, colToShow, multiKeyToStore, initialQuery = "", requestType } = props;
	const dropdownRef = useRef(null);
	const [visible, setVisible] = useState(false);
	const [searchValue, setSearchValue] = useState(initialQuery);
	const [selectedItem, setSelectedItem] = useState(null);
	const [list, setList] = useState();

	useEffect(() => {
		//Add a event listener to the document to close the dropdown if user clicks outside dropdown
		document.addEventListener("mousedown", handleClick, false);
		return () => document.removeEventListener("mousedown", handleClick, false);
	}, []);

	const handleClick = (e) => {
		//If the user clicks outside the dropdown close the dropdown
		if (dropdownRef.current.contains(e.target)) {
			return;
		}
		setVisible(false);
	};

	const handleChange = (e) => {
		//Start search call when search query changes
		setSearchValue(e.target.value);
		search(e.target.value);
		if (!visible) {
			setVisible(true);
		}
	};

	const selectItem = (item) => {
		setSearchValue(item?.[colToShow]);

		if(onChange) {
			let payload = {};
			if(multiKeyToStore) {
				for(const key of colToStore) {
					if(key in item) {
						payload[key] = item[key];
					}
				}
			} else {
				payload = item?.[colToStore];
			}

			console.log(payload)

			onChange(payload);
		}

		setSelectedItem(item?.[colToStore]);
		setVisible(false);
	};

	//Search function to get the search results , uses endpoint prop
	const search = async (keyword) => {
		const url = `${props.endpoint}keyword=${keyword}`
		let response;
		if(requestType === "post") {
			response = await post({ url });
		} else {
			response = await get({ url });
		}
		const { data, error } = response;
		if (data) {
			setList(data);
		}
		if (error) {
		}
	};

	//Take colToStore from user for updating the value on change
	//Take colToShow to show the updated value

	return (
		<Div position="relative" display="" width="100%">
			<InputBox
				type="text"
				placeholder="Search Text"
				value={searchValue}
				onChange={handleChange}
				//Close Dropdown on blur and show it again when inputbox is focused
				onFocus={() => {
					setVisible(true);
				}}
				onBlur={() => {
					setVisible(false);
				}}
				padding="0.7rem"
				width="100%"
			/>
			<Dropdown ref={dropdownRef} className={visible ? "dropdown-open" : "dropdown-close"}>
				{/* Map the results recived from api , if result length is zero show text No result*/}
				{list?.length ? (
					list.map((x) => (
						<Item key={x?.[colToStore]} onClick={() => selectItem(x)}>
							<Text>{x?.[colToShow]}</Text>
						</Item>
					))
				) : (
					<Item>No result</Item>
				)}
			</Dropdown>
		</Div>
	);
};
